import React from 'react';
import * as ThemeUI from 'theme-ui';

export const Card = ({ children, ...props }) => (
  <ThemeUI.Card {...props}>
    {children}
  </ThemeUI.Card>
);
